import React, { useState, useEffect } from "react";
import axios from "axios";
import { gallery as mockGallery } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import SectionBg from "./SectionBg";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Gallery() {
  const { t } = useLang();
  const [images, setImages] = useState(mockGallery);

  useEffect(() => {
    axios.get(`${API}/gallery`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length) {
          setImages(res.data.map((g) => ({ src: g.url, alt: g.alt })));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section id="galleria" className="relative py-24 md:py-32 bg-[#f3ecdf] overflow-hidden">
      <SectionBg section="gallery" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14 reveal">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#C9A24B]" />
            <span className="text-[#B0863B] tracking-[0.3em] text-xs uppercase">{t("gallery.badge")}</span>
            <span className="h-px w-12 bg-[#C9A24B]" />
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-[#23201C] leading-tight">
            {t("gallery.title1")} <span className="italic text-[#C9A24B]">{t("gallery.highlight")}</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {images.map((img, i) => (
            <div key={i}
              className={`group relative overflow-hidden rounded-[2px] reveal ${i === 0 || i === 5 ? "md:row-span-2 md:col-span-2" : ""}`}
              style={{ transitionDelay: `${(i % 4) * 80}ms` }}>
              <img src={img.src} alt={img.alt}
                className={`zoom-img w-full object-cover ${i === 0 || i === 5 ? "h-full min-h-[260px] md:min-h-[520px]" : "h-[240px]"}`} />
              <div className="absolute inset-0 bg-[#1C1815]/0 group-hover:bg-[#1C1815]/40 transition-all duration-500 flex items-end p-5">
                <span className="text-white font-serif-alt text-lg opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">{img.alt}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}